var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-list-item");
/**
 * This component us used to create the one to three lines of text within a
 * `ListItem` or `SimpleListItem`.
 */
export function ListItemText(_a) {
    var className = _a.className, secondaryTextClassName = _a.secondaryTextClassName, secondaryText = _a.secondaryText, children = _a.children;
    var secondaryContent;
    if (secondaryText) {
        secondaryContent = (_jsx("span", __assign({ className: cn(block("text", { secondary: true }), secondaryTextClassName) }, { children: secondaryText })));
    }
    return (_jsxs("span", __assign({ className: cn(block("text"), className) }, { children: [children, secondaryContent] })));
}
//# sourceMappingURL=ListItemText.js.map